import { axios } from '../../services/axios';

const getCompanies = async (currentPartner, currentWholesaler) => {
    const res = await axios.get('/companies/List', {
        params: {
            wholesalerID: currentWholesaler,
            partnerID: currentPartner,
        },
    });
    return res.data;
};

export default getCompanies;
